export default __webpack_public_path__ + "static/media/destination-grid-320_385-Bhopal.b9c94410.png";